import React, { useEffect } from 'react';
import { EditableInput as EditableInputBase } from 'react-color/lib/components/common';
import tinycolor from 'tinycolor2';

import { theme } from '@process-advisor/process-miner/shared/theme';

const inputStyles = {
    input: {
        border: `1px solid ${theme.colors.borderColor}`,
        borderRadius: '4px',
        width: '100%',
        marginTop: '10px',
        padding: '3px',
        height: '24px',
    },
};

type Props = {
    activeColor: string;
    onColorChange: (color: string) => void;
};

export const EditableInput: React.FC<Props> = ({
    activeColor,
    onColorChange,
}) => {
    const [value, setValue] = React.useState(activeColor);

    useEffect(() => {
        setValue(activeColor);
    }, [activeColor]);

    const onChange = (newValue) => {
        setValue(newValue);
        if (tinycolor(newValue).isValid()) {
            onColorChange(newValue);
        }
    };

    return (
        <EditableInputBase
            style={inputStyles}
            value={value}
            onChange={onChange} />
    );
};
